





































































































import isNil from "lodash/isNil";
import Vue from "vue";
import { SelectOption, SelectOptionKey } from "../types";

export default Vue.extend({
  props: {
    value: {
      required: false
    },
    allowEmpty: {
      type: Boolean,
      required: false,
      default: (): boolean => false
    },
    name: {
      type: String,
      required: false
    },
    label: {
      type: String,
      required: true
    },
    error: {
      type: String,
      required: false
    },
    required: {
      type: Boolean,
      required: false,
      default: (): boolean => false
    },
    help: {
      type: String,
      required: false
    },
    placeholder: {
      required: false,
      type: String,
      default: (): string => "Select"
    },
    options: {
      type: Array as () => SelectOption[],
      required: true
    },
    emitOnMount: {
      type: Boolean,
      required: false,
      default: (): boolean => true
    }
  },

  data() {
    return {
      priorSelectingState: null,
      isFocused: false,
      isSelecting: false
    };
  },

  computed: {
    /**
     * Match the option keys to the current value prop to find the currently selected
     * option.
     */
    selectedOption(): SelectOption | null {
      return this.options.find(option => option.key === this.value) || null;
    },

    fieldName(): string | null {
      if (this.selectedOption?.renderOnly) {
        return null;
      }

      return this.name;
    },

    /**
     * Cast non-null field values to strings for use on the underlying form inputs
     */
    inputValue(): string | null {
      if (isNil(this.value)) {
        return null;
      }

      return String(this.value);
    }
  },

  methods: {
    /**
     * When a selection is made, this will be passed the key of the newly selected
     * option.
     */
    updateSelection(key: SelectOptionKey) {
      const option = this.options.find(
        option => String(option.key) === String(key)
      );

      this.isSelecting = false;
      this.$emit("input", option?.key, option);
    }
  }
});
